/**
 * tell you what the index number of the first data on this page is
 */
const itemStartFrom = (currentPage, numberInPage) => {
	if (typeof currentPage !== 'number' || typeof numberInPage !== 'number') {
		return false;
	}

	if (currentPage === 1) {
		return 0;
	}

	return ((currentPage - 1) * numberInPage);
};

export default itemStartFrom;



// WEBPACK FOOTER //
// ./src/js/about/itemStartFrom.js